import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PayoutDateList from "./PayoutDateList";
import PayoutTransactionList from "./PayoutTransactionList";
import "./css/adminpayoutstore.css";

const StatItem = ({ className, label, total }) => (
  <div className={className}>
    <div className="adminpayoutstore-info-title">{label}</div>
    <div className="adminpayoutstore-info-amount">{total.toLocaleString()}원</div>
  </div>
);

const AdminPayoutStore = () => {
  const navigate = useNavigate();
  const { storeCode } = useParams();
  const { state } = useLocation();
  const [activeTab, setActiveTab] = useState("completed");
  const [pgStatus, setPgStatus] = useState(true);
  const storeName = state?.storeName ?? "";
  const filterMode = state?.filterMode ?? "dateRange";
  const filters = state?.filters ?? { startDate: "", endDate: "", year: "", month: "" };
  const returnPath = state?.returnPath ?? "/admin/payout";

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [listTotals, setListTotals] = useState({ sales: 0, pgFee: 0, cpFee: 0, payout: 0 });

  const handleDateSelect = (date, summary) => {
    setSelectedDate(date);
    setSelectedSummary({ sales: summary.sales, fee: summary.fee, payout: summary.payout });
  };

  const handleBack = () => {
    setSelectedDate(null);
    setSelectedSummary(null);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPgStatus(tab === "completed");
  };

  return (
    <div className="adminpayoutstore-container">
      {/* 상단 헤더 */}
      <div className="adminpayoutstore-information">
        <div className="adminpayoutstore-info-store">
          <div className="adminpayoutstore-info-store-left">
            <div className="adminpayoutstore-storecode">{storeCode}</div>
            <div className="adminpayoutstore-storename">{storeName}</div>
          </div>
          {selectedDate ? (
            <button className="adminpayoutstore-btn-back" onClick={handleBack}>
              날짜 목록으로
            </button>
          ) : (
            <button className="adminpayoutstore-btn-back" onClick={() => navigate(returnPath)}>
              가맹점 목록
            </button>
          )}
        </div>
        <div className="adminpayoutstore-info-date">
          {selectedDate ? (
            <>
              <div className="adminpayoutstore-date">{selectedDate}</div>
              <div className="adminpayoutstore-total">
                <div className="adminpayoutstore-info-title">총 결제 금액</div>
                <div className="adminpayoutstore-info-amount">
                  {selectedSummary?.sales?.toLocaleString()}원
                </div>
              </div>
              <div className="adminpayoutstore-ver-divider" />
              <div className="adminpayoutstore-fee">
                <div className="adminpayoutstore-info-title">수수료</div>
                <div className="adminpayoutstore-info-amount">
                  {selectedSummary?.fee?.toLocaleString()}원
                </div>
              </div>
              <div className="adminpayoutstore-ver-divider" />
              <div className="adminpayoutstore-payout">
                <div className="adminpayoutstore-info-title">실 정산액</div>
                <div className="adminpayoutstore-info-amount">
                  {selectedSummary?.payout?.toLocaleString()}원
                </div>
              </div>
            </>
          ) : (
            <>
              <StatItem
                className="adminpayoutstore-total"
                label="총 매출액"
                total={listTotals.sales}
              />
              <div className="adminpayoutstore-ver-divider" />
              <StatItem
                className="adminpayoutstore-pgfee"
                label="PG 수수료"
                total={listTotals.pgFee}
              />
              <div className="adminpayoutstore-ver-divider" />
              <StatItem
                className="adminpayoutstore-cpfee"
                label="자사 수수료"
                total={listTotals.cpFee}
              />
              <div className="adminpayoutstore-ver-divider" />
              <StatItem
                className="adminpayoutstore-payout"
                label="실 정산액"
                total={listTotals.payout}
              />
            </>
          )}
        </div>
      </div>
      
      
      {/* 하단 목록 */}
      {selectedDate ? (
        <PayoutTransactionList
          storeCode={storeCode}
          payoutPeriodDate={selectedDate}
          isCompleted={returnPath === "/admin/payout/completed"}
        />
      ):(
        <PayoutDateList
          storeCode={storeCode}
          storeName={storeName}
          filterMode={filterMode}
          filters={filters}
          isCompleted={returnPath === "/admin/payout/completed"}
          activeTab={activeTab}
          pgStatus={pgStatus}
          onDateSelect={handleDateSelect}
          onTabChange={handleTabChange}
          onTotalsChange={setListTotals}
        />
      )}
    </div>
  );
};

export default AdminPayoutStore;
